const ORGADMIN_ROLE = 'organization-admin';

// Connector and Employee are the same role, but 'employee' is used on the backend. Use `connector` anywhere user-facing
const EMPLOYEE_ROLE = 'employee';
const CONNECTOR_ROLE = 'connector';
const SCHOOLADMIN_ROLE = 'school-admin';
const EDUCATOR_ROLE = 'educator';
const DE_ROLE = 'de-admin';
const STUDENT_ROLE = 'student';
// "Group Admin" in Auth0 groups metadata normalizes to 'group-admin' (spaces → hyphens, lowercase)
const GROUPADMIN_ROLE = 'group-admin';

// TODO: Create the 'volunteer' role, and make it backward compat with employee role behind the scenes
// Also, delete the connector role, its legacy and unused.
// School admin is also unused - analysis needed
// Keep student role, but since its a 'blocked' role, we must delete all usages of it elsewhere.
export default {
    CONNECTOR_ROLE,
    ORGADMIN_ROLE,
    EMPLOYEE_ROLE,
    SCHOOLADMIN_ROLE,
    EDUCATOR_ROLE,
    DE_ROLE,
    STUDENT_ROLE,
    GROUPADMIN_ROLE,
};
